import React from 'react'
import { Text, StyleSheet, View } from '@react-pdf/renderer'
import PropTypes from 'prop-types'
import Checkbox from '../components/Checkbox'

MensHistory.propTypes = {
  data: PropTypes.array,
}

export default function MensHistory({ data }) {
  const styles = StyleSheet.create({
    title: {
      fontWeight: 'bold',
      color: '#AF924D',
      marginLeft: 5,
      marginBottom: 10,
    },
    question: {
      marginLeft: 5,
    },
    container: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      // marginTop: 10,
    },
    label: {
      display: 'flex',
      flexDirection: 'row',
      margin: 5,
    },
    underScore: {
      borderBottom: '1px solid black',
      flex: 1,
      padding: 0,
      paddingLeft: 5,
      marginLeft: 10,
    },
  })

  return (
    <>
      {data.map((el) => (
        <React.Fragment key={el.id}>
          {el.type === 'checkbox' ? (
            <>
              <View style={styles.container}>
                <Text style={styles.question}>{el.question}</Text>
                {JSON.parse(el.answer).map((check) => (
                  <React.Fragment key={check.code}>
                    {check.fillabel ? (
                      <View style={styles.container}>
                        <Checkbox
                          isCheck={check.checked}
                          text={check.value}
                          style={{ margin: 5 }}
                        />
                        <Text style={styles.underScore}>{check.answer}</Text>
                      </View>
                    ) : (
                      <Checkbox isCheck={check.checked} text={check.value} style={{ margin: 5 }} />
                    )}
                  </React.Fragment>
                ))}
              </View>
            </>
          ) : el.type === 'radio' ? (
            <View style={styles.container}>
              <Text style={styles.question}>{el.question}</Text>
              {JSON.parse(el.answer).map((check) => (
                <Checkbox
                  key={check.code}
                  isCheck={check.selected}
                  text={check.value}
                  style={{ margin: 5 }}
                />
              ))}
            </View>
          ) : el.type === 'text' ? (
            <View style={styles.label}>
              <Text>{el.question}</Text>
              <Text style={styles.underScore}>{el.answer}</Text>
            </View>
          ) : el.type === 'questions_arr' ? (
            <>
              <Text style={{ ...styles.question, marginBottom: 10 }}>{el.question}</Text>
              {JSON.parse(el.answer).map((check) => (
                <View key={check.code} style={styles.label}>
                  <Text>{check.question}</Text>
                  <Text style={styles.underScore}>{check.answer}</Text>
                </View>
              ))}
            </>
          ) : null}
        </React.Fragment>
      ))}
      {/* <Text style={styles.question}>(Check box if applicable)</Text>
      <View style={styles.container}>
        <Checkbox isCheck={false} text="Testicular mass" style={{ margin: 5 }} />
        <Checkbox isCheck={false} text="Testicular pain" style={{ margin: 5 }} />
        <Checkbox isCheck={false} text="Prostate enlargement" style={{ margin: 5 }} />
        <Checkbox isCheck={false} text="Prostate infection" style={{ margin: 5 }} />
        <Checkbox isCheck={false} text="Change in sex drive" style={{ margin: 5 }} />
        <Checkbox isCheck={false} text="Impotence" style={{ margin: 5 }} />
        <Checkbox isCheck={false} text="Premature ejaculation" style={{ margin: 5 }} />
        <Checkbox isCheck={false} text="Difficulty obtaining an erection" style={{ margin: 5 }} />
        <Checkbox isCheck={false} text="Difficulty maintaining an erection" style={{ margin: 5 }} />
        <Checkbox isCheck={false} text="Lost of control of urine" style={{ margin: 5 }} />
        <Checkbox
          isCheck={false}
          text="Urinary urgency/hesitancy/change in stream"
          style={{ margin: 5 }}
        />
        <Checkbox isCheck={false} text="Vasectomy" style={{ margin: 5 }} />
        <View style={{ ...styles.label, marginLeft: 0 }}>
          <Checkbox
            isCheck={false}
            text="Nocturia (urination at night) # of times per night"
            style={{ margin: 5 }}
          />
          <Text style={styles.underScore}></Text>
        </View>
        <View style={{ ...styles.label, marginLeft: 0 }}>
          <Checkbox
            isCheck={false}
            text="Sexually transmitted diseases (describe)"
            style={{ margin: 5 }}
          />
          <Text style={styles.underScore}></Text>
        </View>
      </View>

      <Text style={styles.question}>Screening/Procedures: (If applicable, provide date)</Text>
      <View style={styles.container}>
        <View style={styles.container}>
          <Text style={styles.question}>Last PSA test:</Text>
          <Text style={{ ...styles.underScore, width: '60%' }}></Text>
        </View>

        <View style={styles.container}>
          <Text style={styles.question}>PSA Level:</Text>
          <Checkbox isCheck={false} text="0-2" style={{ margin: 5 }} />
          <Checkbox isCheck={false} text="2-4" style={{ margin: 5 }} />
          <Checkbox isCheck={false} text="4-10" style={{ margin: 5 }} />
          <Checkbox isCheck={false} text=">10" style={{ margin: 5 }} />
        </View>
      </View>
      <View style={styles.container}>
        <Text style={styles.question}>Other tests/procedures (list type and dates)</Text>
        <Text style={styles.underScore}></Text>
      </View> */}
    </>
  )
}
